import { gql } from "@apollo/client";

// ============================================================================
// HOMEPAGE QUERIES
// ============================================================================

import { GENERAL_FIELDS, SITE_FIELDS, PAGE_SETTINGS } from "./shared";
import { HERO_INTRO_IMAGE, HERO_INTRO_IMAGE_MOBILE } from "./fragments/heroIntroImage";
import { SECTIONS_WRAPPER_QUERY } from "./fragments/sections";

export const HOMEPAGE_QUERY = gql`
  ${SITE_FIELDS}
  ${GENERAL_FIELDS}
  ${PAGE_SETTINGS}
  ${HERO_INTRO_IMAGE}
  ${HERO_INTRO_IMAGE_MOBILE}
  ${SECTIONS_WRAPPER_QUERY}
  query GetHomepage($locale: SiteLocale!) {
    site: _site(locale: $locale) {
      ...SiteFields
    }
    general(locale: $locale) {
      ...GeneralFields
    }
    fields: homepage(locale: $locale) {
      # Homepage Meta (SEO)
      titles: _allTitleLocales(locale: $locale) {
        locale
        value
      }
      seoMetaTags: _seoMetaTags(locale: $locale) {
        attributes
        content
        tag
      }

      # Homepage Fields (Content)
      title
      intro {
        value
      }

      introImage {
        ...HeroIntroImage
      }
      introImageMobile: introImage {
        ...HeroIntroImageMobile
      }

      # Homepage Components
      pageSettings {
        ...PageSettings
      }
      sections {
        ...SectionWrapperQuery
      }
    }
  }
`;
